export const GET_MODIFIER_LIST = "GET_MODIFIER_LIST"
export const CREATE_MODIFIER = "CREATE_MODIFIER"
export const UPDATE_MODIFIER = "UPDATE_MODIFIER"
export const DELETE_MODIFIER = "DELETE_MODIFIER"
